import type { BackendError } from '@/types/errors'

const parseBackendError = (error: unknown): string | undefined => {
    try {
        const e = error as Error
        const errorString = e.message

        const parts = errorString.split('|').map((part) => part.trim())

        const statusCode = parts[0]
        const statusMessage = parts[1]
        const errorObject = JSON.parse(parts[2]) as BackendError

        const result = [statusCode, statusMessage, errorObject.title].join(' | ')
        return result
    } catch {
        return undefined
    }
}

const parseBackendErrorMessage = (errorString: string): string | undefined => {
    if (!errorString || errorString.length === 0) return undefined
    const errorObject = JSON.parse(errorString) as BackendError
    const { errors } = errorObject
    const result = Object.entries(errors)
        .map(([value, key]) => {
            return `${value}: ${key.join(', ')}`
        })
        .join(' | ')
    return result
}

export { parseBackendError, parseBackendErrorMessage }
